module.exports = __webpack_public_path__ + "static/media/walking-liberty-coin.0e83de0f.png";